// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tableBox[data-v-7c39b226]{height:calc(100% - 260px)}.colorStyle[data-v-7c39b226]{color:red}.mdTitName[data-v-7c39b226]{height:24px;border:1px solid #d7d7d7;text-align:center;min-width:100px}.saveBtn[data-v-7c39b226]{margin:0 auto;background-color:#f0a261;color:#fff;padding:10px 20px}.detailsBtns[data-v-7c39b226]{width:78px;text-align:center;color:#2c6ae1;display:block!important;cursor:pointer}.topTipsstyle[data-v-7c39b226]{display:flex;align-items:center}", ""]);
// Exports
module.exports = exports;
